module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0097.jpg?v=d472178e";